import AbstractDateTimePicker from "./abstract-date-time-picker";

export class TimePicker extends AbstractDateTimePicker {
    protected options(): {} {
        return $.extend(true, super.options(), {
            display: {
                viewMode: 'clock',
                components: {
                    calendar: false,
                    clock: true,
                },
            },
            localization: {
                format: 'HH:mm',
            },
        });
    }
}

// noinspection JSUnusedGlobalSymbols
export default () => {
    for (const $datePickerElement of $('.timepicker')) {
        new TimePicker($datePickerElement).createPicker();
    }
}